export default __webpack_public_path__ + "static/media/File-No-2.488237d2.pdf";